import React from 'react';

const Unauthorized = () => {
    return <div className="ac-page">
        <h1>Resource Unavailable</h1>
            <p>You do not have access to the requested resource or your session has expired.</p>
            <p>Please check your URL and start over again.</p>
    </div>
}

export default Unauthorized;